export const DEFAULT_VIDEO_HEIGHT = 1080;
export const DEFAULT_VIDEO_WIDTH = 1920;
export const EVENTS_LIST = ['play', 'ready', 'pause', 'finish'];
export const METHODS_LIST = ['getVideoWidth', 'getVideoHeight'];
export const DOCUMENT_EVENTS = ['click', 'keydown', 'touchstart', 'touchend'];

const MAX_SPACING = 200;
const DEFAULT_VIDEO_CONFIG = {
  controls: true,
  title: false,
  byline: false,
  portrait: false,
  transparent: false,
  quality: 'auto',
  width: '100%',
  fullscreen: true
};

export const getSpacing = ({ width, height }) => {
  if (!width || !height) {
    return 0;
  }

  return Math.min((height / width) * 100, MAX_SPACING);
};

export const getVideoURL = ({ url, loop = false, autoplay = false }) => {
  const src = new URL(url);
  Object.entries({
    ...DEFAULT_VIDEO_CONFIG,
    autoplay,
    loop
  }).forEach(([key, value]) => {
    src.searchParams.set(key, String(value));
  });

  return src.toString();
};

export const getParsedMessageData = (data = {}) => {
  return typeof data === 'string' ? JSON.parse(data) : data;
};

export const postMessage = ({ element, action, value }) => {
  const data = {
    method: action
  };

  if (value) {
    data.value = value;
  }

  const message = JSON.stringify(data);

  if (element) element.contentWindow.postMessage(message, '*');
};
